import { Container } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="sm-footer">
      <Container>
        <div className="sm-footer-grid">
          <div className="sm-footer-about">
            <a href="/" className="sm-brand">
              <span className="sm-brand-name">
                <img className="logo-image" src={require("../assets/images/logo.png")} alt="GoCart" />
              </span>
            </a>
            <p className="sm-footer-desc">
              A modern digital marketplace connecting farmers, vendors and
              customers through simpler trade and better visibility.
            </p>
          </div>

          <div className="sm-footer-links">
            <p className="sm-footer-heading">Platform</p>
            <a href="#marketplace">Marketplace</a>
            <a href="/dashboard">Vendor Dashboard</a>
            <a href="/order-mangement/order-management-view">Order Management</a>
            <a href="/transaction-history">Transactions</a>
          </div>

          <div className="sm-footer-links">
            <p className="sm-footer-heading">Company</p>
            <a href="/">About</a>
            <a href="/contact-us">Contact</a>
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/terms-condition">Terms and Conditions</a>
          </div>
        </div>
      </Container>

      <div className="sm-footer-bottom">
        <Container>
          <div className="sm-footer-bottom-inner">
            <p>© 2026 GoCart. All rights reserved.</p>
            <p>Designed for modern agricultural commerce.</p>
          </div>
        </Container>
      </div>
    </footer>
  );
};
export default Footer;
